// removed by extract-text-webpack-plugin
module.exports = {"telephoneLinkStyle":"TVLaterAlert__telephoneLinkStyle","tvLaterContentStyle":"TVLaterAlert__tvLaterContentStyle","mb15":"TVLaterAlert__mb15","mb10":"TVLaterAlert__mb10"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/TVLaterAlert/TVLaterAlert.scss
// module id = 2353
// module chunks = 8